import React, { PureComponent } from 'react';
import {CSVLink} from 'react-csv';
import TableSort from '../../../../components/table/TableSort';
import './style.scss';
import { connect } from 'react-redux';
import { ACTIONS, getTeamStartMember, getTeamStarter, convertDataTeamStarter } from './../../../../actions/team-start-member';
import { ACTIONS_MASTER, getYearData } from './../../../../actions/master';
import Loading from '../../../../components/loading';
import { downloadFileCsv } from './../../../../common/services/downloadCsv';
import moment from 'moment';
import { month } from './../../../../common/enum/index';


class TeamStarter extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            listDataStarter: [],
            yearData : [],
            monthData: [],
            showLoading: false,
            currentYearId: null,
            currentMonthId: moment().format('MM'),
            currentTeamId: null,
            boardItems: [],
            dataStarterRaw: [],
            listCsv: [],
        }
        this.onRedirect = this.onRedirect.bind(this);
    }

    componentDidMount() {
        this.setState({
            showLoading: true,
            monthData: month,
            currentTeamId: this.props.match.params.id
        });
        this.props.getYearData().then(response => {
            const params = {
                team_id: this.props.match.params.id,
                year_id: response[0].year_id,
                month_id: this.state.currentMonthId
            };
            this.props.getTeamStarter(params);
            this.props.getTeamStartMember(params);
            this.setState({ currentYearId: response[0].year_id, yearData: response });
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.status === ACTIONS.GET_TEAM_STARTER_SUCCESS ) {
            this.setState({
                showLoading: false
            })
        }

        if (nextProps.response) {
            if (nextProps.responseYear) {
                if (nextProps.statusYear === ACTIONS_MASTER.GET_YEAR_SUCCESS) {
                    this.setState({
                        yearData: nextProps.responseYear,
                    })
                }
            }

            if (nextProps.status === ACTIONS.GET_TEAM_STARTER_SUCCESS ) {
                if (nextProps.response.length > 0) {
                    let firstGame = nextProps.response[0];
                    let month = new Date(firstGame.game_date).getMonth();
                    let newMonthData = [...this.state.monthData];
                    if(!newMonthData[month]) return;
                    newMonthData[month].active = true;
                    this.setState({
                        monthData: newMonthData,
                    })
                }
                const data = convertDataTeamStarter(nextProps.response);
                const listCsv = [];

                data.forEach(item => {
                    listCsv.push([item.titleTable]);
                    listCsv.push(item.headersBatter.map(head => head.text));
                    const valueBatter = [];
                    item.itemBatter.forEach(value => {
                        valueBatter.push(value.item.map(pitcher => `${pitcher.position || ''} ${pitcher.text || ''}`));
                    });
                    listCsv.push(...valueBatter);
                    listCsv.push(this.props.header2.map(head => head.text));
                    const valuePitcher = [];
                    item.itemPitcherBackupOpponent.forEach(value => {
                        valuePitcher.push(value.item.map(pitcher => `${pitcher.position || ''} ${pitcher.text || ''}`));
                    });
                    listCsv.push(...valuePitcher);
                });
                this.setState({
                    listDataStarter: data,
                    dataStarterRaw : nextProps.response,
                    listCsv: listCsv,
                })
            }
        } else {
            this.setState({
                listDataStarter: [],
                dataStarterRaw: []
            })
        }
    }

    getYearData(e) {

        this.setState({
            currentYearId: e.target.value,
            showLoading: true
         }, () => {
            const data = {
                team_id: this.state.currentTeamId,
                year_id: this.state.currentYearId,
                month_id: this.state.currentMonthId
            }
            this.props.getTeamStarter(data);
            this.props.getTeamStartMember(data);
         })

    }

    activeMonth(monthId) {
        this.setState({
            showLoading: true,
            currentMonthId: monthId
        },() => {
            const data = {
                team_id: this.state.currentTeamId,
                year_id: this.state.currentYearId,
                month_id: this.state.currentMonthId
            }
            this.props.getTeamStarter(data);
        })
    }

    downloadCsvStarter(table, filename) {
        downloadFileCsv(table, filename);
    }

    onRedirect() {
        this.props.history.push(`/dashboard-team?id=${this.state.currentTeamId}`);
    }

    redirectToPlayer(index, name) {
        let batterList = this.state.dataStarterRaw[index].batters;
        let player = batterList.find((batter) => {
            return batter.player.player_name === name;
        })
        this.props.history.push(`/player/${player.player.id}`);
    }

    redirectToGame(index) {
        let game = this.state.dataStarterRaw[index];
        let gameDate = new Date(game.game_date);
        this.props.history.push(`/game/${game.id}/${this.state.currentTeamId}/${moment(gameDate).format('YYYYMMDD')}`, {
            finish: true
        });
    }

    render() {
        return (
            <div className="team-starter">
                <section className="block-control">
                    <div className="head--tables-right">
                        <select className="form-control" onChange={(e) => this.getYearData(e)}>
                            {
                                this.state.yearData.map((v, i)  => {
                                    return <option key={i} value={v.year_id}>{ v.year }</option>
                                })
                            }
                        </select>
                    </div>
                    <div className="block-button">
                        <CSVLink className={'csv-download'}
                                 headers={this.props.header}
                                 data={this.state.listCsv} filename={'team-starter.csv'}>
                            CSVダウンロード
                        </CSVLink>
                    </div>
                </section>
                <section className="block-board">
                    {this.props.boardItems.map((item, index) => (
                        <div className="block-board__item" style={{cursor: 'pointer'}} onClick={() => this.onRedirect(item)} key={index.toString()}>
                            <span className="sub-text">{item.subText}</span>
                            <span className="main-text">{item.mainText}</span>
                        </div>
                    ))}
                </section>
                <section className="block-content" id='team-starter'>
                    <div className="control">
                        {
                            this.state.monthData.map((val, i) => {
                                return <button key={i} onClick={() => this.activeMonth(val.id)}  type="button" className={`btn-radius ${val.id === this.state.currentMonthId ? 'active' : ''}`}>{ val.month }</button>
                            })
                        }
                    </div>

                    {
                        this.state.listDataStarter.map((val, i) => {
                            return (
                                <div className="wrapper" key={i}>
                                    <p className="title-table" onClick={() => this.redirectToGame(i)}>{ val.titleTable }</p>
                                    <TableSort
                                        header={val.headersBatter}
                                        showCheckbox={false}
                                        showSearch={false}
                                        itemOfPage={val.itemBatter}
                                        isShowOptionTable={false}
                                        showPagination={false}
                                        onColumnClick={(index, data) => this.redirectToPlayer(i, data.item[index].text)}
                                    />
                                    <div style={{height: 8}}></div>
                                    <TableSort
                                        header={this.props.header2}
                                        showCheckbox={false}
                                        showSearch={false}
                                        itemOfPage={val.itemPitcherBackupOpponent}
                                        isShowOptionTable={false}
                                        showPagination={false}
                                    />
                                </div>
                            )
                        })
                    }
                </section>
                <Loading show={this.state.showLoading} />
            </div>
        );
    }
}

const mapStateToProps = ({ teams, master }) => {
    return {
        boardItems: teams.boardItems,
        header1: teams.headerStart1,
        header2: teams.headerStart2,
        dataTable1: teams.dataTableStart1,
        dataTable2: teams.dataTableStart2,
        responseYear: master.response,
        statusYear: master.status,
        response: teams.response,
        status: teams.status
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getTeamStartMember: (data) => {
            dispatch(getTeamStartMember(data));
        },
        getYearData: () => dispatch(getYearData()),
        getTeamStarter: (data) => {
            dispatch(getTeamStarter(data))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure : false })(TeamStarter);
